import {
    hasSuperadminPrivileges,
    type ActiveRoleAssignmentResponse,
} from '@pillar-portal/api-types';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { AdminSessionsListPage } from '@/components/profile/admin-sessions-list-page';
import { sessionSensitiveAuthApi } from '@/lib/sessionSensitiveAuthApi';
import { getActiveRoleAssignmentOperationalResponse } from '@/lib/active-role-assignment';

function SessionsRouteContent() {
    const activeRoleAssignmentQuery = useQuery<ActiveRoleAssignmentResponse | null>({
        queryKey: ['activeRoleAssignment'],
        queryFn: async () => await sessionSensitiveAuthApi.getActiveRoleAssignment(),
        staleTime: 30000,
    });

    if (activeRoleAssignmentQuery.isLoading) {
        return <div>Loading...</div>;
    }

    if (
        !hasSuperadminPrivileges(
            getActiveRoleAssignmentOperationalResponse(activeRoleAssignmentQuery.data)
        )
    ) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <MainLayout>
            <AdminSessionsListPage />
        </MainLayout>
    );
}

export default function SessionsPage() {
    return (
        <ProtectedRoute>
            <SessionsRouteContent />
        </ProtectedRoute>
    );
}
